import { Injectable } from "@angular/core";
import { DataService } from "@app/core/services/data.service";
import { CashRegisterSettingsDto } from "@app/models";
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class CashRegisterSettingsService {
  serviceUrl = "cashregistersettings";

  constructor(private http: DataService) {}

  getSettings(): Observable<CashRegisterSettingsDto[]> {
    return this.http.get(this.serviceUrl);
  }

  saveSettings(modes: CashRegisterSettingsDto[]): Observable<CashRegisterSettingsDto[]> {
    return this.http.put(this.serviceUrl, { modes });
  }
}
